import React, { Suspense } from 'react';
import { memberId } from '@trello/session-cookie';
import { useLazyComponent } from '@trello/use-lazy-component';
import { HeaderSkeleton } from 'app/src/components/HeaderSkeleton';
import styles from './Header.less';
import {
  LoggedOutNavExperimentVariations,
  useLoggedOutHeaderExperiment,
} from 'app/src/components/LoggedOutHeader';

export const Header = () => {
  const HeaderContainerWithProviders = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "header" */ 'app/src/components/Header/HeaderContainer'
      ),
    { namedImport: 'HeaderContainerWithProviders' },
  );

  // Do NOT send an exposure event yet
  const loggedOutHeaderVariation = useLoggedOutHeaderExperiment();

  const headerStyles =
    !memberId &&
    loggedOutHeaderVariation === LoggedOutNavExperimentVariations.EXPERIMENT
      ? styles.marketingHeader
      : styles.header;

  return (
    <div
      data-desktop-id="header"
      // needed for hiding the header in madlibs and moonshot
      // create-first-board and create-first-team
      data-js-id="header-container"
      className={headerStyles}
    >
      <Suspense fallback={<HeaderSkeleton />}>
        <HeaderContainerWithProviders />
      </Suspense>
    </div>
  );
};
